// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Knxl4","inner":"Footer_inner__3fQmL"};